import { FundProjectionScreenOutlined, HistoryOutlined, SwapOutlined } from '@ant-design/icons';

const analise = {
  id: 'group-analise',
  title: 'Análise',
  type: 'group',
  children: [
    {
      id: 'transacoes',
      title: 'Transações',
      type: 'item',
      url: '/transacoes',
      icon: SwapOutlined,
      breadcrumbs: false
    },
    {
      id: 'projecao',
      title: 'Projeção',
      type: 'item',
      url: '/projecao',
      icon: FundProjectionScreenOutlined,
      breadcrumbs: false
    },
    {
      id: 'historico',
      title: 'Histórico',
      type: 'item',
      url: '/historico',
      icon: HistoryOutlined,
      breadcrumbs: false
    }
  ]
};

export default analise;
